import { call, put, takeLatest } from 'redux-saga/effects';
import handleException from '../services/handleException';
import { getListItemName } from '../utils/getListItemName';
import { GET_LIST_ITEM_NAME, GET_LIST_ITEM_NAME_SUCCESS } from './../actions/getListItemName';

function* getlistItemNameSaga() {
    yield takeLatest(GET_LIST_ITEM_NAME, getListItemNameHandle)
}

function* getListItemNameHandle(action) {
    try {
        const response = yield call(getListItemName, action.payload)

        if (response.data.code === 10001) {
            yield put({ type: GET_LIST_ITEM_NAME_SUCCESS, payload: response })
        } else {
            handleException(response)
        }
    } catch (error) {
        handleException(error)
    }
}

export default getlistItemNameSaga


// WEBPACK FOOTER //
// ./src/sagas/getListItemNameSaga.js